(function($) {

    var ios = navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
    var focusAfterAnim = false;

    /**
     * Remove animations on ios devices, focus issue.
     */
    if(ios) {
        $('.search-form-container').css('transition', 'none');
        $('.search-form-container form').css('transition', 'none');
    }

    /**
     * Toggle search field visibility and give input focus when 
     * shown.
     */
    $('.search-toggle').on('click', function(e) { 
        
        var $body = $('body');
        var $input = $('.search-input');

        $body.toggleClass('search-toggled');

        if($body.hasClass('search-toggled')) {
            
            $input.click();
            $input.focus();
            focusAfterAnim = (ios) ? false : true;
        } else {
            focusAfterAnim  = false;
        }
    });

    /**
     * Set focus after animation is completed. Doing it earlier
     * will result in focus a issue.
     */
    $('.search-form-container').on('transitionend MSTransitionEnd webkitTransitionEnd oTransitionEnd', function(event) {

        if (focusAfterAnim) {
            
            var $body = $('body');
            var $input = $('.search-input');

            if($body.hasClass('search-toggled')) {
                $input.click();
                $input.focus();
                focusAfterAnim = false;
            }
        }
    });

    /**
     * Close search dialog when input gets out of focus.
     */
    $('.search-input').blur(function() {
        var $body = $('body');
        if ($body.hasClass('search-toggled')) {
            $body.removeClass('search-toggled');
            // We need to manually close the typeahead modal window.
            $('.tt-container').hide();
        }
    });

})(jQuery);
